import publicContent from "./content/public-content.json";

const SITE_URL = "https://proteo.fitness";
const OG_IMAGE = `${SITE_URL}/og-image.jpg`;
const SOCIAL_PREVIEWS = publicContent.socialPreviews;

// The generator reads the same JSON contract from seo/meta.mjs. Keeping this
// browser-facing module free of Node JSON import attributes avoids bundler
// warnings while hydrated pages and static crawler HTML share their copy.
export const HOME_SEO = {
  ...SOCIAL_PREVIEWS.home,
  path: "/",
  type: "website" as const,
  image: OG_IMAGE,
};

export const PRIVACY_SEO = {
  ...SOCIAL_PREVIEWS.privacy,
  path: "/privacy/",
  type: "website" as const,
  image: OG_IMAGE,
};

export const TERMS_SEO = {
  ...SOCIAL_PREVIEWS.terms,
  path: "/terms/",
  type: "website" as const,
  image: OG_IMAGE,
};
